/**
 * /en/admin/structure/paragraphs_type/form_element_submit/fields
 */

import CLASS_NAMES from "../constants/css-constants.es6.js";
import LinkField from "../core/link-field.es6.js";
import FormElementParagraph from "../paragraphs/form-element-paragraph.es6.js";

export default class SubmitFormElementParagraph extends FormElementParagraph {
  get errorLink() {
    return new LinkField({
      machineName: 'field_error_link',
      parentElement: this,
    });
  }

  get successLink() {
    return new LinkField({
      machineName: 'field_success_link',
      parentElement: this,
    });
  }

  constructor({ parentElement }) {
    super({
      machineName: 'form_element_submit',
      parentElement,
    });
  }

  toggleLoadingState(loading) {
    const $loader = this.$().find(`.${CLASS_NAMES.LOADING}`);
    if (loading) {
      $loader.removeClass(CLASS_NAMES.HIDDEN);
    } else {
      $loader.addClass(CLASS_NAMES.HIDDEN);
    }
  }
}
